import { api } from "@/lib/api";
import { usePolling } from "@/hooks/usePolling";
import { BenchmarkTriple } from "@/components/data/BenchmarkTriple";

export default function YieldPage() {
  const { data, error } = usePolling(() => api.get("/intelligence/yield").then((r) => r.data), 5000);

  if (error) return <div className="text-sm text-[var(--oim-text-muted)]" data-testid="yield-error">Could not load yield layer.</div>;
  if (!data) return <div className="text-sm text-[var(--oim-text-muted)]" data-testid="yield-loading">Loading…</div>;

  const cards = [
    ["Chlorination selectivity (Benzene)", data.chlorination_selectivity],
    ["Isomer yield — Benzene route", data.isomer_yield_bz],
    ["Isomer yield — Toluene route", data.isomer_yield_tl],
    ["Hydrogenation conversion — Benzene", data.hydrogenation_conversion_bz],
    ["Hydrogenation conversion — Toluene", data.hydrogenation_conversion_tl],
  ];

  return (
    <div className="space-y-4" data-testid="yield-page">
      <h1 className="text-2xl font-bold font-heading text-[var(--oim-text)]">Yield & Selectivity</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {cards.map(([label, q]) => (
          <div key={label} className="rounded-xl border p-4" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
            <BenchmarkTriple label={label} unit={q.unit} {...q} testId={`benchmark-${label.replace(/[^a-zA-Z]/g, "-")}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
